// extracted by mini-css-extract-plugin
export var card = "_k2-5";
export var cardSelected = "_k2-4";
export var image = "_k2-3";
export var modal = "_k2-0";
export var modalContent = "_k2-1";
export var table = "_k2-2";